export const isSubmitting = () => {
    document.getElementById('submitForm').disabled ? document.getElementById('submitForm').disabled = false : document.getElementById('submitForm').disabled = true;
};

export const getUser = () => {
    return JSON.parse(sessionStorage.getItem('user'))[0];
}

export const removeUser = () => {
    sessionStorage.removeItem('user')
}

export const decideBody = (user, login=false) => {
    switch(user.tipouser){
        case 2:
            console.log(login)
            return login == true ? {codTurma: user.codturma}: {codTurma: user.codturma}
        case 3:
            return {idFilial: user.idfilial}
        case 4:
            return {idEscola: user.idescola}
        case 6:
            return {idFilial: user.idfilial}
        
    }
}

export const decideName = (user) => {
    switch(user.tipouser){
        case 1:
            return user.nomeres
        case 2:
            return user.codturma
        case 3:
            return user.nomefilial
        case 4:
            return user.nomeescola
        case 5:
            return user.nomeusuario
        case 6:
            return user.nomeporteiro
    }
}

export const getDate = () => {
    const dataAtual = new Date();

    const ano = String(dataAtual.getFullYear());
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const dia = String(dataAtual.getDate()).padStart(2, '0');

    const hora = String(dataAtual.getHours()).padStart(2, '0');
    const minutos = String(dataAtual.getMinutes()).padStart(2, '0');
    const segundos = String(dataAtual.getSeconds()).padStart(2, '0');

    return `${ano}-${mes}-${dia} ${hora}:${minutos}:${segundos}`;
}

export const getMySQLDate = () => {
    const now = new Date();
  
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`
      
}